export enum OrderStatus {
  progg = 18,
  esec = 13,
  plan = 7,
  guarantee = 35,
  deliberate = 38,
}
